import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import { getMovieGenres, getMovieTags, Movie } from '@usheru-hff/shared/domain';
import { TRACKING_SERVICE, TrackingService } from '@usheru-hff/sdk/tracking';

import { AnswerSelection } from '../entities/answer-selection.model';
import { CompetitionAnswer } from '../entities/competition-answer.model';
import { CompetitionQuestion } from '../entities/competition-question.model';
import { Competition } from '../entities/competition.model';

@Component({
    selector: 'ush-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    standalone: false
})
export class QuestionComponent {
  @Input()
  movie!: Movie;

  @Input()
  question!: CompetitionQuestion;

  @Input()
  competition!: Competition;

  @Output()
  answerPicked = new EventEmitter<AnswerSelection>();

  selection!: CompetitionAnswer;

  constructor(@Inject(TRACKING_SERVICE) private trackingService: TrackingService) {}

  pickAnswer(answer: CompetitionAnswer): void {
    this.selection = answer;
    this.answerPicked.next({
      questionId: this.question.id,
      answer: answer
    });

    this.trackingService.trackEvent({
      action: 'SelectAnswer',
      properties: {
        category: 'Competitions',
        label: `${this.competition.title} @ ${this.movie?.title}`,
        movie: this.movie?.title,
        idMovie: this.movie?.id,
        tagsMovie: getMovieTags(this.movie),
        genresMovie: getMovieGenres(this.movie),
        imdb: this.movie?.imdb,
        competitionTitle: this.competition.title,
        idCompetition: this.competition.id
      }
    });
  }
}
